import MojitoCore from 'mojito/core';
import RoutingControllerImpl from './routing-controller.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Module for RoutingController that handles the application's routing functionality.
 *
 * @class RoutingController
 * @memberof Mojito.Applications.Sports
 */

export default UIView('RoutingController', RoutingControllerImpl);
